import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { MAX_MEDIUM_INPUT_TEXT_LENGTH } from '@mews-commander/constants';
import { dateString, maxInputTextLength, maxTextLength, presence, ValidationRules } from '@mews-commander/legacy-form';

import { FieldName, FormValues } from './types';

type Constraints = {
    [K in keyof FormValues]?: ValidationRules;
};

interface GetConstraintsParams {
    isCreateForm?: boolean;
    isCreatingFromRates?: boolean;
}

const getAllConstraints = ({ isCreateForm, isCreatingFromRates }: GetConstraintsParams): Constraints => ({
    name: {
        presence,
        length: maxTextLength(MAX_MEDIUM_INPUT_TEXT_LENGTH),
    },
    properties: {
        presence,
    },
    occupiableIntervalStartUtc: {
        dateString,
    },
    occupiableIntervalEndUtc: {
        dateString,
    },
    rateKeys: {
        presence: isCreateForm && !isCreatingFromRates ? presence : undefined,
    },
    key: {
        length: maxInputTextLength,
    },
});

export interface GetConstraintsProps {
    isCreateForm?: boolean;
    enabledFields?: Array<FieldName>;
    unlockedFields?: Array<FieldName>;
    isCreatingFromRates?: boolean;
}

export const getConstraints = ({
    enabledFields,
    isCreateForm,
    unlockedFields,
    isCreatingFromRates,
}: GetConstraintsProps) => {
    const constraints = getAllConstraints({ isCreateForm, isCreatingFromRates });

    if (!enabledFields) {
        return constraints;
    }

    return pipe(
        Object.keys(constraints),
        array.filter(
            (key) => enabledFields?.includes(key as FieldName) || !!unlockedFields?.includes(key as FieldName)
        ),
        array.reduce({} as Constraints, (obj, key) => {
            obj[key as FieldName] = constraints[key as FieldName];
            return obj;
        })
    );
};
